document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-duexbrox-scroll-indicator').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('.shopify-section');
      var next = section ? section.nextElementSibling : null;
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});